import React, { useState } from 'react';
import {
  Box,
  Typography,
  Button,
  Stack,
  Container,
  Grid,
  Card,
  CardContent,
} from '@mui/material';

import { AccessTime, Chat, CheckCircle, Group, GroupAdd, Insights, LocationPin, Money, Search, Shield } from '@mui/icons-material';
import { useRef, useEffect } from 'react';


import NewsletterModal from './NewsletterModal';
import SalesModal from './SalesModal';

import axios from 'axios';

import demoVideo from '../assets/demo_video.mp4';

import company1 from '../assets/customer1.png';
import company2 from '../assets/customer2.png';
import company3 from '../assets/customer3.png';
import company4 from '../assets/customer4.png';

const SubCard = ({ icon, title, content }) => (
  <Grid item xs={12} sm={4}>
    <Card elevation={1} sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <CardContent sx={{ flexGrow: 1 }}>
        <Box sx={{ fontSize: 32, mb: 1 }}>{icon}</Box>
        <Typography variant="subtitle1" fontWeight={600} gutterBottom>
          {title}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {content}
        </Typography>
      </CardContent>
    </Card>
  </Grid>
);

const ProblemSolutionSection = ({ id, title, blurb, bgColor, cards }) => (
  <Box id={id} sx={{ py: 8, backgroundColor: bgColor }}  display='flex' maxWidth="40%" alignItems='center'>
    <Container>
      <Card elevation={3}>
        <CardContent>
          <Typography variant="h4" fontWeight={600} gutterBottom>
            {title}
          </Typography>
          <Typography variant="body1" color="textSecondary" mb={4}>
            {blurb}
          </Typography>
          <Grid container spacing={3}>
            {cards.map((card, index) => (
              <SubCard
                key={index}
                icon={card.icon}
                title={card.title}
                content={card.content}
              />
            ))}
          </Grid>
        </CardContent>
      </Card>
    </Container>
  </Box>
);

const CardItem = ({ title, content, icon }) => (
  <Grid item>
    <Card
      elevation={2}
      sx={{
        width: 300,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <CardContent sx={{ flexGrow: 1 }}>
        <Box sx={{ fontSize: 40, mb: 1 }}>{icon}</Box>
        <Typography variant="h6" fontWeight={600} gutterBottom>
          {title}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {content}
        </Typography>
      </CardContent>
    </Card>
  </Grid>
);


const HomePage = () => {
  const [openNewsletter, setOpenNewsletter] = useState(false);
  const [openSalesModal, setOpenSalesModal] = useState(false);
  const [body, setBody] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
    role: '',
    company: '',
    // yoe: '',
    comments: '',
    // interests: {
    //   findingNewLeads: false,
    //   leadEnrichment: false,
    //   reachingOutToLeads: false,
    //   advisorDevelopment: false,
    //   other: false,
    // },
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const videoRef = useRef('../assets/demo_video.mp4');

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.playbackRate = 1.4;
    }
  }, []);

  const handleFormChange = (e) => {
    if (e.target.name === 'interests') {
      setBody((prev) => ({
        ...prev,
        interests: {
          ...prev.interests,
          [e.target.value]: e.target.checked,
        },
      }));
    }
    else {
      setBody((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    }
  };

  const handleNewsletterSubmit = async (event) => {
      event.preventDefault()

      if (!body.firstName || !body.lastName || !body.phone || !body.email) {
        setError('Please fill in all required fields.');
        setSuccess('');
        return;
      }

      const phoneRegex = /^\+?[1-9]\d{1,14}$/;
      if (!phoneRegex.test(body.phone)) {
        setError('Please enter a valid phone number.');
        setSuccess('');
        return;
      }

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(body.email)) {
        setError('Please enter a valid email address.');
        setSuccess('');
        return;
      }

      const response = await axios.post('https://0urp7fhu11.execute-api.us-east-2.amazonaws.com/prod/send-email', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body
      })
      if (response.status === 200) {
        alert('Thank you for signing up! We will be in touch.')
        setBody({
          firstName: '',
          lastName: '',
          phone: '',
          email: '',
          company: '',
          yoe: '',
          comments: '',
          interests: {
            findingNewLeads: false,
            leadEnrichment: false,
            reachingOutToLeads: false,
            advisorDevelopment: false,
            other: false,
          },
        });
        setOpenNewsletter(false)
        setOpenSalesModal(false)
      } else {
        alert('There was an issue with your submission. Please try again.')
      }
    }


  return (
    <Box>
      {/* Hero Section */}
      <Box
        sx={{
          backgroundColor: '#eeeeee',
          minHeight: '90vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          px: 2,
          textAlign: 'center',
        }}
        id="hero"
      >
        <Typography variant="h3" fontWeight={600} gutterBottom>
        Smarter Prospecting for Early-Career Financial Advisors
        </Typography>

        <Typography variant="body1" color="textSecondary" maxWidth="600px" mb={4}>
        Unlock precise wealth segments, identify timely money-in-motion events, and convert prospects into lasting clients. Grow to $30M AUM and beyond—fast.
        </Typography>
        <Box sx={{ mt: 4, mb: 4, maxWidth: '900px', mx: 'auto' }}>
  <video
    ref={videoRef}
    src={demoVideo}
    style={{
      width: '100%',
      borderRadius: '12px',
      objectFit: 'cover',
      boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    }}
    autoPlay
    muted
    loop
    playsInline // important for mobile autoplay
  />
</Box>



        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
          <Button 
            variant="contained" 
            color="primary" 
            sx={{ textTransform: 'none' }}
            onClick={() => setOpenSalesModal(true)}
          >
            Early Access
          </Button>
          <Button
              variant="outlined"
              color="primary"
              sx={{ textTransform: 'none' }}
              onClick={() => setOpenNewsletter(true)}
            >
              Talk to Sales
            </Button>

            <NewsletterModal
              open={openNewsletter}
              onClose={() => setOpenNewsletter(false)}
              formData={setBody}
              onChange={handleFormChange}
              onSubmit={handleNewsletterSubmit}
              error={error}
              success={success}
            />
            <SalesModal
              open={openSalesModal}
              onClose={() => setOpenSalesModal(false)}
              formData={setBody}
              onChange={handleFormChange}
              onSubmit={handleNewsletterSubmit}
              error={error}
              success={success}
            />
        </Stack>
      </Box>

      {/* Problem Section */}
      <Box id="problem" sx={{ py: 8, backgroundColor: '#fafafa' }}>
        <Container >
          <Typography variant="h4" fontWeight={600} gutterBottom>
            The Problem We Solve
          </Typography>
          <Grid
            container
            spacing={4}
            justifyContent="center"
            sx={{ margin: '0 auto' }}
          >
            <ProblemSolutionSection
              id="problem"
              title="The Problem"
              blurb="Early-career financial advisors struggle to efficiently identify prospects who genuinely need financial advice. Generic prospecting methods lead to wasted effort and low conversions, slowing the path to growth."
              bgColor="#fdecea" // light red
              cards={[
                {
                  icon: '🕑',
                  title: 'An Uphill Battle for Early Career Advisors',
                  content: '72% of new advisors quit during onboarding, and as many as 90% fail by their third year. Without robust referral networks, new advisors struggle to convince skeptical prospects.',
                },
                {
                  icon: '📉',
                  title: 'Traditional Lead Generation Tools Fall Short',
                  content: 'Gut-feel prospecting leads to poor conversions.',
                },
                {
                  icon: '🎯',
                  title: 'Lack of Precise Segmentation & Personalization',
                  content: '82% of advisors believe effective segmentation is crucial for growth, yet most find it exceedingly difficult without actionable insights into life events and financial circumstances.',
                },
              ]}
            />

            <ProblemSolutionSection
              id="solution"
              title="Our Solution"
              blurb="Pathvizor transforms your prospecting by pinpointing precise segments of individuals experiencing compelling financial life events. Reach prospects exactly when they are most receptive, aligned perfectly with your advisory service offerings."
              bgColor="#e8f5e9" // light green
              cards={[
                {
                  icon: '⚡',
                  title: 'Precision Client Segmentation',
                  content: 'Quickly filter and create segments based on factors relevant to your service level and niche, focusing on emerging wealth segments like "HENRYs" (High Earners, Not Rich Yet).',
                },
                {
                  icon: '🔔',
                  title: 'Proactive Wealth & Life Event Signals',
                  content: "Identify key financial inflection points—events that historically indicate openness to financial guidance, allowing you to engage prospects when they're naturally receptive."
                },
                {
                  icon: '📈',
                  title: 'Exclusive 401(k) Analytics',
                  content: 'Provide prospects with valuable insights into their existing 401(k) holdings, establishing immediate credibility and unlocking conversations about broader wealth management.',
                },
              ]}
            />
          </Grid>
        </Container>
      </Box>

            {/* How It Works Section */}
            <Box id="how" sx={{ py: 8, backgroundColor: '#fafafa' }}>
        <Container>
         <Box display="flex" flexDirection="column" alignItems="center">
            <Typography variant="h4" fontWeight={600} gutterBottom style={{ marginBottom: "16px" }}>
              How It Works
            </Typography>

            <Typography variant="body1" color="textSecondary" maxWidth="600px" gutterBottom style={{ marginBottom: "16px" }}> 
            Pathvizor combines sophisticated predictive models and proprietary data to surface compelling wealth triggers and real-time money-in-motion events.
            </Typography>
          </Box>
          <Grid
            container
            spacing={4}
            justifyContent="center"
            sx={{ maxWidth: 1000, margin: '0 auto' }}
          >
            <CardItem
              title="1. Define Your Market"
              content="Select your preferred local markets, roles, wealth levels, and life-stage criteria to focus your prospecting efforts."
              icon={<LocationPin fontSize="inherit" />}
            />
            <CardItem
              title="2. Discover Prospects"
              content="Instantly access enriched profiles including estimated net worth, inferred income, and compelling life events."
              icon={<Search fontSize="inherit" />}
            />
            <CardItem
              title="3. Deepen Conversations"
              content="Leverage exclusive 401(k) insights and comprehensive financial data to add immediate value before your first meeting."
              icon={<Chat fontSize="inherit" />}
            />
          </Grid>
        </Container>
      </Box>

      {/* Features Section */}
      <Box id="features" sx={{ py: 8 }}>
        <Container>
        <Box display="flex" flexDirection="column" alignItems="center">
            <Typography variant="h4" fontWeight={600} gutterBottom style={{ marginBottom: "16px" }}>
              Key Features
            </Typography>

            <Typography variant="body1" color="textSecondary" maxWidth="600px" gutterBottom style={{ marginBottom: "16px" }}> 
            Our platform delivers the actionable insights early-career advisors need to grow their book efficiently.
            </Typography>
          </Box>
          <Grid
            container
            spacing={4}
            justifyContent="center"
            sx={{ maxWidth: 1000, margin: '0 auto' }}
          >
            <CardItem
              title="Precise Wealth Segmentation"
              content="Filter prospects by wealth indicators, professional roles, and financial profiles (e.g., HENRYs - High Earners, Not Rich Yet)."
              icon={<Group fontSize="inherit" />}
            />
            <CardItem
              title="Compelling Life Events"
              content="Identify prospects experiencing critical financial life events signaling openness to advisory relationships, including inheritance, job changes, marriage, divorce, and more."
              icon={<Insights fontSize="inherit" />}             
            />
            <CardItem
              title="Enriched Prospect Profiles"
              content="Access verified contact data, estimated net worth, home values, and LinkedIn profiles to craft highly personalized outreach."
              icon={<GroupAdd fontSize="inherit" />}
            />
            <CardItem
              title="Exclusive 401(k) Data Insights"
              content="Proprietary reports featuring fund lineup analysis, company matching, vesting schedule, and fees. "
              icon={<Money fontSize="inherit" />}             
            />
            <CardItem
              title="Timely, Fresh Data"
              content="Regular data updates ensure advisors access prospects in real-time, precisely when financial advice is top-of-mind."
              icon={<AccessTime fontSize="inherit" />}
            />
          </Grid>
        </Container>
      </Box>

      {/* Why Us Section */}
      <Box id="why" sx={{ py: 8 }}>
        <Container>
        <Box display="flex" flexDirection="column" alignItems="center">
            <Typography variant="h4" fontWeight={600} gutterBottom style={{ marginBottom: "16px" }}>
            Why Advisors Win with Pathvizor
            </Typography>
          </Box>
          <Grid
            container
            spacing={4}
            justifyContent="center"
            sx={{ maxWidth: 1000, margin: '0 auto' }}
          >
            <CardItem
              title="Close More, Faster"
              content="Meet prospects at precisely the right financial moment—eliminate cold outreach."
              icon={<AccessTime fontSize="inherit" />}
            />
            <CardItem
              title="Build Instant Credibility"
              content="Demonstrate immediate value with detailed financial insights from proprietary employer-sponsored plan data."
              icon={<Shield fontSize="inherit" />}

            />
            <CardItem
              title="Align Conversations with Intent"
              content="No more awkward networking—every meeting starts with clear financial relevance, enabling authentic conversations."
              icon={<CheckCircle fontSize="inherit" />}
            />
          </Grid>
        </Container>
        {/* <Box sx={{ py: 8, backgroundColor: '#f9f9f9' }}>
  <Container maxWidth="lg">
    <Typography
      variant="h5"
      fontWeight={600}
      align="center"
      gutterBottom
      sx={{ mb: 4 }}
    >
      Trusted by Advisors At:
    </Typography>

    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 4,
      }}
    >
      {[company1, company2, company3, company4].map((logo, idx) => (
        <Box
          component="img"
          key={idx}
          src={logo}
          alt={`Customer logo ${idx + 1}`}
          sx={{
            height: 40,
            objectFit: 'contain',
            opacity: 0.8,
          }}
        />
      ))}
    </Box>
  </Container>
</Box> */}
      </Box>
    </Box>
  );
};

export default HomePage;
